import { createContext } from 'react'

export const contextValues = {
    lang: ''
}

export const LanguageContext = createContext(contextValues)